module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGfeb2a57d0b372f82d90e9287201849ba.feb2a57d.png";